import useSWR from "swr";

import { simpleFetcher } from "../fetcher";
import { type TierDetails } from "../types";

const url = "/api/v2/tiers";

export function useTiers() {
  const { data, error, mutate } = useSWR<TierDetails[], Error>(
    url,
    simpleFetcher,
    { revalidateOnFocus: false, revalidateIfStale: false },
  );

  const sortedTiers = data
    ?.map((tier) => {
      let order = 0;
      let currentTier = tier;

      // Walk up the parent chain to count levels
      while (currentTier.parentId !== null) {
        order++;
        currentTier = data.find((t) => t.id === currentTier.parentId)!;
      }

      return {
        ...tier,
        order,
      };
    })
    .sort((a, b) => a.order - b.order);

  return { data: sortedTiers, error, mutate };
}
